import React from 'react';
import ReactDOM from "react-dom";
import 'www/main';
import 'sass/www/freddie.scss';
import analytics from 'common/util/analytics';

analytics(googleAnalyticsTrackId);
